import { render, staticRenderFns } from "./DepartmentHistory.vue?vue&type=template&id=b7dd1238&scoped=true&lang=pug&"
import script from "./scripts/DepartmentHistory.js?vue&type=script&lang=js&"
export * from "./scripts/DepartmentHistory.js?vue&type=script&lang=js&"
import style0 from "./DepartmentHistory.vue?vue&type=style&index=0&id=b7dd1238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dd1238",
  null
  
)

export default component.exports